<template>
  <div>
    <b-modal
      :id="modalId"
      :scrollable="true"
      title="MRS Record"
      header-bg-variant="success"
      size="lg"
      centered
      hide-footer>
      <b-row>
        <b-col sm="6">
          <b-form-group label="Invoice No">
            <b-input v-model="localForm.invoiceNo" size="sm" />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Date of Service">
            <date-picker
              v-model="localForm.dateService"
              :shortcuts="false"
              :popup-style="{'top': '0px'}"
              input-class="form-control form-control-sm"
              format="YYYY-MM-DD"
              width="100%"
              lang="en" />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Milage">
            <b-input v-model="localForm.mileage" size="sm" />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Work Shop">
            <v-select
              v-model="localForm.workShop"
              :options="workshopList"
              @search="fetchWorkshops" />
          </b-form-group>
        </b-col>
        <!-- Invoice items -->
        <b-col sm="12">
          <hr>
          <b-btn size="sm" variant="success" class="mb-3" @click="addInvoiceItem">
            <i class="fa fa-plus" /> Item
          </b-btn>
          <b-table-simple v-if="localForm.items.length">
            <b-thead head-variant="light">
              <b-th></b-th>
              <b-th>Job Description</b-th>
              <b-th>Work Carried Out</b-th>
              <b-th>Quantity</b-th>
              <b-th>Unit Price</b-th>
              <b-th>Price</b-th>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(item, idx) in localForm.items" :key="idx">
                <b-td>
                  <b-btn variant="link" size="sm" @click="removeItem(idx)">
                    <i class="fa fa-close text-danger font-md" />
                  </b-btn>
                </b-td>
                <b-td>
                  <b-select v-model="localForm.items[idx].jobDesc" size="sm">
                    <option v-for="(value, idx) in jobDescList" :key="idx" :value="value">{{ value }}</option>
                  </b-select>
                </b-td>
                <b-td>
                  <b-input v-model="localForm.items[idx].workCarriedOut" size="sm" />
                </b-td>
                <b-td>
                  <b-input v-model.number="localForm.items[idx].quantity" size="sm" type="number" min="0" />
                </b-td>
                <b-td>
                  <b-input v-model.number="localForm.items[idx].unitPrice" size="sm" type="number" min="0" />
                </b-td>
                <b-td>
                  <b-input v-model.number="localForm.items[idx].price" size="sm" type="number" min="0" />
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>
      <hr>
      <div class="text-right">
        <b-btn
          :disabled="isSubmitting"
          variant="primary"
          @click="handleSubmit">{{ isEdit ? 'Edit' : 'Add' }}</b-btn>
      </div>
    </b-modal>

  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'
import { mapState } from 'vuex'

export default {
  name: 'MRSModal',
  components: {
    DatePicker,
    vSelect
  },
  props: {
    modalId: {
      type: String,
      required: true
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    doneSubmitting: {
      type: Boolean,
      default: false
    },
    selectedInvoice: {
      type: Object,
      default: () => {},
      required: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('workshop', ['workshopList'])
  },
  data () {
    return {
      localForm: { items: [] },
      jobDescList: [
        '61000030 Car Maintenance - Regular',
        '61000035 Car Maintenance - Mechanical',
        '61000040 Car Maintenance - Accident',
        '61000080 Motor Vehicle Insurance',
        '61000090 Inspection fee',
        '61000100 Delivery/Collection Charges',
        '61000110 Car Sharing Supplies/Expenses',
        '61000120 Fleet Partner Payment',
        '00000000 Warranty Claim'
      ]
    }
  },
  watch: {
    selectedInvoice: {
      immediate: true,
      handler: function (nVal) {
        if (nVal && Object.keys(nVal).length > 1) {
          this.localForm = nVal
        } else {
          this.localForm = { items: [] }
        }
      }
    },
    doneSubmitting: {
      handler: function (nVal) {
        if (nVal) {
          this.localForm = { items: [] }
        }
      },
      immediate: true
    }
  },
  methods: {
    addInvoiceItem () {
      this.localForm.items.push({
        jobDesc: '',
        workCarriedOut: '',
        price: undefined
      })
    },
    removeItem (idx) {
      this.localForm.items.splice(idx, 1)
    },
    handleSubmit () {
      // format date
      this.localForm.dateService = this.$options.filters.date(this.localForm.dateService, 'YYYY-MM-DD')
      this.$emit('added', this.localForm)
    },
    fetchWorkshops: debounce(function(search) {
      this.$store.dispatch('workshop/fetchWorkshops', { vendor: search, nameOnly: true })
    }, 300)
  }
}
</script>